import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api } from '../api.js';
import Spinner from '../components/Spinner.jsx';
import Badge from '../components/Badge.jsx';

const CAT_LABEL = {
  theorie: '📚 Theorie',
  praxis_trocken: '🏋 Praxis trocken',
  ausbildungstauchgang: '🤿 Ausbildungstauchgang',
};

export default function VorDemDienst() {
  const { id } = useParams();
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [checking, setChecking] = useState(null);

  const load = () => {
    setLoading(true);
    api.getProgress(id, true)
      .then(setData)
      .catch(console.error)
      .finally(() => setLoading(false));
  };
  useEffect(load, [id]);

  const markDone = async (itemId) => {
    setChecking(itemId);
    try {
      await api.setProgress(id, { item_id: itemId, status: 'vermittelt' });
      load();
    } finally { setChecking(null); }
  };

  if (loading) return <div className="flex justify-center py-12"><Spinner size="lg" /></div>;
  if (!data)   return <p className="text-red-600">Fehler beim Laden.</p>;

  const items    = data.items ?? [];
  const student  = data.student;
  const byCategory = {};
  for (const item of items) {
    (byCategory[item.category] ??= []).push(item);
  }

  return (
    <div className="space-y-4">
      {/* Breadcrumb */}
      <div className="flex items-center gap-2 text-sm text-gray-500">
        <Link to="/ausbilder" className="hover:text-blue-600">Schüler</Link>
        <span>/</span>
        <Link to={`/ausbilder/schueler/${id}`} className="hover:text-blue-600">{student.kuerzel}</Link>
        <span>/</span>
        <span className="font-medium text-gray-900">Vor dem Tauchdienst</span>
      </div>

      <div className="card bg-amber-50 border-amber-200">
        <p className="text-sm font-medium text-amber-800">
          🎯 Offene Inhalte für <strong>{student.kuerzel}</strong> · Stufe {student.stufe_ziel}
        </p>
        <p className="text-xs text-amber-600 mt-0.5">
          {items.length === 0
            ? 'Alle Pflichtinhalte wurden vermittelt!'
            : `${items.length} noch offene Einheiten`}
        </p>
      </div>

      {items.length === 0 && (
        <div className="card text-center py-10 text-green-700">
          <p className="text-3xl mb-2">✅</p>
          <p className="font-semibold">Alle Inhalte sind erledigt!</p>
        </div>
      )}

      {Object.entries(byCategory).map(([cat, catItems]) => (
        <div key={cat} className="space-y-2">
          <h2 className="text-xs font-semibold uppercase tracking-wide text-gray-500">
            {CAT_LABEL[cat] ?? cat}
          </h2>
          {catItems.map((item) => (
            <div key={item.id}
              className="card flex items-center gap-4 active:scale-[.99] transition-transform cursor-pointer hover:border-blue-200"
              onClick={() => markDone(item.id)}
            >
              <div className="shrink-0">
                {checking === item.id
                  ? <Spinner size="sm" />
                  : <div className="h-6 w-6 rounded border-2 border-gray-300 flex items-center justify-center hover:border-blue-500" />
                }
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-1.5 flex-wrap">
                  <span className="text-sm font-medium text-gray-800">{item.title}</span>
                  <Badge type={item.requirement} />
                </div>
                <p className="text-xs text-gray-400 mt-0.5">{item.topic}</p>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
